import styled from "@emotion/styled";

export const OrderDetailsLineItemRowContainer = styled.div<{ isClickable: boolean }>(({ theme, isClickable }) => ({
	padding: "16px",
	backgroundColor: theme.project.colors.backgroundColors.card,
	border: `1px solid ${theme.project.colors.allColors.hex.grayscale.gray300}`,
	cursor: isClickable ? "pointer" : "auto",
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	position: "relative",
	"&:hover": {
		backgroundColor: isClickable ? theme.project.colors.backgroundColors["card:hover"] : "none"
	}
}));

export const OrderDetailsLineItemRowContent = styled.div({
	display: "flex",
	flexDirection: "column" as const,
	gap: 0
});

export const OrderDetailsLineItemRowRow = styled.div<{ isReviewOrder?: boolean }>(({ theme, isReviewOrder }) => ({
	display: "grid",
	gridTemplateColumns: `370px 2fr 2fr 3fr 3fr ${isReviewOrder ? ".5fr" : "2fr"}`,
	alignItems: "center",
	columnGap: "8px",
	[theme.breakpoints.down("md")]: {
		display: "flex",
		flexDirection: "column",
		gap: "8px",
		alignItems: "flex-start"
	}
}));

export const OrderDetailsLineItemRowIcon = styled.svg(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary,
	alignSelf: "center",
	justifySelf: "right",
	position: "absolute",
	top: "32px",
	right: "16px",
	[theme.breakpoints.down("md")]: {
		top: "30px"
	}
}));

export const OrderDetailsLineItemLabel = styled.span(({ theme }) => ({
	textAlign: "right",
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	[theme.breakpoints.down("md")]: {
		display: "flex",
		justifyContent: "flex-end",
		width: "100px"
	}
}));

export const OrderDetailsLineItemValueColumn = styled.div(({ theme }) => ({
	textAlign: "right",
	display: "flex",
	flexDirection: "column",
	[theme.breakpoints.down("md")]: {
		flexDirection: "row",
		gap: "8px"
	}
}));

export const OrderDetailsLineItemCashValueColumn = styled(OrderDetailsLineItemValueColumn)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		justifyContent: "space-between",
		width: "100%"
	}
}));

export const OrderDetailsLineItemValuePrimary = styled.span(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.secondary
}));

export const OrderDetailsLineItemValueSecondary = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const OrderDetailsLineItemModRow = styled(OrderDetailsLineItemRowRow)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		gap: 0,
		flexDirection: "row",
		justifyContent: "space-between"
	}
}));

export const OrderDetailsLineItemRowSku = styled.div(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		gap: "0px !important"
	}
}));

export const OrderDetailsLineItemSkuRow = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	color: theme.project.colors.fontColors.main
}));

export const OrderDetailsLineItemQuantity = styled.span(({ theme }) => ({
	width: "32px",
	display: "block",
	...theme.project.typography.body.body1
}));

export const OrderDetailsLineItemSkuCode = styled.span(({ theme }) => ({
	...theme.project.typography.heading.h6
}));

export const OrderDetailsLineItemDescriptionRow = styled.div(({ theme }) => ({
	display: "flex",
	color: theme.project.colors.fontColors.secondary
}));

export const OrderDetailsLineItemDescriptionSpacer = styled.span({
	width: "32px"
});

export const OrderDetailsLineItemDescription = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2,
	fontSize: "16px"
}));

export const OrderDetailsLineItemRowModSku = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	color: theme.project.colors.fontColors.main,
	gridColumn: "1 / 3",
	[theme.breakpoints.down("md")]: {
		gap: "0px",
		width: "100%",
		position: "relative",
		paddingBottom: "24px",
		"> span:last-of-type": {
			position: "absolute",
			bottom: "8px",
			left: "48px"
		}
	}
}));

export const OrderDetailsLineItemModNumber = styled.span(({ theme }) => ({
	width: "48px",
	flexShrink: 0,
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const OrderDetailsLineItemModSkuCode = styled.span(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	marginRight: "12px"
}));

export const OrderDetailsLineItemModDescription = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2
}));

export const OrderDetailsLineItemPromotionRowGrid = styled(OrderDetailsLineItemRowRow)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		flexDirection: "row",
		width: "100%",
		justifyContent: "space-between",
		gap: "8px",
		"> div": {
			display: "none"
		},
		"> span:first-of-type": {
			textAlign: "left"
		}
	}
}));

export const OrderDetailsLineItemFinalPriceGrid = styled(OrderDetailsLineItemPromotionRowGrid)(({ theme }) => ({
	span: { color: theme.project.colors.primaryColors.main }
}));

export const OrderDetailsLineItemPromotionLabel = styled.span(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.secondary,
	textAlign: "right",
	gridColumn: "1 / 5"
}));

export const OrderDetailsLineItemPromotionValue = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	textAlign: "right"
}));
